module.exports = __webpack_public_path__ + "img/Dantam Hair 47.fba92111.jpg";